import config from "src/config";
import { ResponseDto } from 'src/dtos/common/responseDto';
import { deleteData, getData, patchData, postData } from 'src/utils/axios/serverHelper';
import { KSK1030_R01DetailDto, KSK1030_R01Dto, KSK1030_R01HeaderDto, KSK1030_R01LotDto } from "./Dto_KSK1030_R01";


const baseUrl = `${config.apiUrl}/KSK1030_R01`;

export interface KSK1030_R01ListParams {
	startDate?: string;
	endDate?: string;
	customCd?: string;
	listLength?: number;
}

const getParams = (params: KSK1030_R01ListParams) => {
	return {
		startDate: params.startDate || undefined,
		endDate: params.endDate || undefined,
		customCd: params.customCd || undefined,
		listLength: params.listLength || 0
	}
}

export const getKSK1030_R01List = async (option: string, params: KSK1030_R01ListParams, listLength: number = 0) => {
	const url = `${baseUrl}/${option}`;
	return await getData<ResponseDto<KSK1030_R01HeaderDto[]>>(url, { params: getParams({ ...params, listLength }) });
}

export const getKSK1030_R01AllCount = async (params: KSK1030_R01ListParams) => {
	const url = `${baseUrl}/allCount`;
	return await getData<ResponseDto<number>>(url, {
		params: getParams(params)
	});
}

export const getKSK1030_R01One = async (wmsOrderNo: string) => {
	const url = `${baseUrl}/one/${wmsOrderNo}`;
	return await getData<ResponseDto<KSK1030_R01HeaderDto>>(url);
}

export const getKSK1030_R01TransportHeader = async (wmsOrderNo: string) => {
	const url = `${baseUrl}/transport/${wmsOrderNo}`;
	return await getData<ResponseDto<KSK1030_R01HeaderDto>>(url);
}

export const getKSK1030_R01DetailList = async (wmsOrderNo: string, warehouseCd: string) => {
	const url = `${baseUrl}/detail/${wmsOrderNo}/${warehouseCd}`;
	return await getData<ResponseDto<KSK1030_R01DetailDto[]>>(url);
}

/** 창고 재고 LOT 조회 (출고량 입력용) */
export const getKSK1030_R01LotList = async (warehouseCd: string, itemCd: string, itemStatus: string) => {
	const url = `${baseUrl}/lot`;
	return await getData<ResponseDto<KSK1030_R01LotDto[]>>(url, {
		params: {
			warehouseCd: warehouseCd || undefined,
			itemCd: itemCd || undefined,
			itemStatus: itemStatus || undefined
		}
	});
}

export const postKSK1030_R01 = async (data: KSK1030_R01Dto) => {
	const url = `${baseUrl}`;
	return await postData<KSK1030_R01Dto, ResponseDto<KSK1030_R01Dto[]>>(url, data);
}

export const patchKSK1030_R01 = async (data: KSK1030_R01Dto) => {
	const url = `${baseUrl}`;
	return await patchData<KSK1030_R01Dto, ResponseDto<KSK1030_R01Dto[]>>(url, data);
}

export const deleteKSK1030_R01 = async (wmsOrderNo: string) => {
	const url = `${baseUrl}`;
	return await deleteData<ResponseDto<any>>(url, {
		params: { wmsOrderNo }
	});
}

export const downloadExcel_KSK1030_R01 = async (option: string, wmsOrderNo: string, warehouseCd: string, listLength: number = 0) => {
	const url = `${baseUrl}/excel/${option}`
	return await getData<ResponseDto<string>>(url, {
		params: { wmsOrderNo, warehouseCd }
	})
}
